import { HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PagerModule } from '@progress/kendo-angular-pager';
import { ANALYTICS_INITIALIZIER_PROVIDER, AuthenticationService, ClCommonAngularModule, ExperienceModule, IReleaseNoteService, LoggerService, LOGGER_PROVIDER, } from 'cl-common-angular';
import { BlockUIModule } from 'ng-block-ui';
import { ToastrModule } from 'ngx-toastr';
import { AnonymousModule } from './anonymous/anonymous.module';
import { AppInterceptors } from './app-interceptors';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthService } from './core/data/auth.service';
import { ReleaseNoteService } from './core/data/release-note.service';
import { LogService } from './core/data/log.service';

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        HttpClientModule,
        HttpClientXsrfModule.withOptions({
            cookieName: 'XSRF-TOKEN-SS',
            headerName: 'X-XSRF-TOKEN'
        }),

        BlockUIModule.forRoot(),

        ClCommonAngularModule,

        AppRoutingModule,

        AnonymousModule,

        ToastrModule.forRoot({
            closeButton: true,
            positionClass: 'toast-top-center',
            timeOut: 3000
        }),

        PagerModule,

        ExperienceModule.forRoot({
            experienceUrl: 'https://experience-dev-devinternal.elluciancloud.com',
            headerKitUrl: 'https://experience-dev-devinternal.elluciancloud.com/headerkit/loader.js',
            querySelector: '#experience-controls',
        })
    ],
    providers: [
        ANALYTICS_INITIALIZIER_PROVIDER,
        AppInterceptors,
        { provide: AuthenticationService, useClass: AuthService },
        { provide: IReleaseNoteService, useClass: ReleaseNoteService },
        { provide: LoggerService, useClass: LogService },
        LOGGER_PROVIDER,
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
